import { ICommand } from "yfiles";
export default (graphComponentRef) => {
    if (!graphComponentRef.current)
        return undefined;
    return () => {
        ICommand.DELETE.execute(null, graphComponentRef.current);
    };
};
